import { type FC } from 'react';
import { Badge } from '@mantine/core';
import { formatOrder, payoutOrderPublicStatusColors, type PayoutOrderPublicStatus } from '~/entities/payout';

interface OrderStatusBadgeProps {
    status?: PayoutOrderPublicStatus;
    fullWidth?: boolean;
}

export const OrderStatusBadge: FC<OrderStatusBadgeProps> = ({ status, fullWidth = false }) => {
    if (!status) {
        return null;
    }

    return (
        <Badge
            variant='dot'
            fullWidth={fullWidth}
            color={payoutOrderPublicStatusColors[status]}
        >
            {formatOrder.publicStatus(status)}
        </Badge>
    );
};
